import React from 'react';
import BranchBasicInfoComponent from './branch-basic-info.component';
import BranchAddressComponent from './branch-address.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';

function BranchComponent ({ handleInnerbasicFormChange, branchTypes, back, handleFormSubmit, onInnerFormChange, organizationUnits, selectedAddress, selectedBranch }: any) {
    const tabItems=[
        {
            id:1,
            title:'Basic Information',
            component: <BranchBasicInfoComponent
            onInnerFormChange={onInnerFormChange}
            organizationUnits={organizationUnits}
            selectedBranch={selectedBranch}
            branchTypes={branchTypes}
        />,
        isVisible:true,
        },
        {
            id:2,
            title:'Address',
            component: <BranchAddressComponent 
            handleInnerbasicFormChange={handleInnerbasicFormChange}
            onInnerFormChange={onInnerFormChange}
            selectedBranch={selectedBranch} 
            selectedAddress={selectedAddress}
           />,
            isVisible:true,
        }
     
      
      ]
  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
       
     
    <TabContainer tabItems={tabItems} />
 
    <div className='flex w-full justify-end items-end'>
      <button
            onClick={back}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
           >
            Back
           </button>
           <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            onClick={handleFormSubmit}
          
            type="submit"
        >
          Save
        </button>
      </div>
     </div>
  );
}
export default BranchComponent;
